module.exports = __webpack_public_path__ + "img/背抠兔子.7d3bc34b.png";